import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { EmpresasService } from 'app/services/empresas/empresas.service';
import Swal from "sweetalert2";
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import { MessagesStatus } from 'app/models/messages';

@Component({
  selector: 'app-sector-empresa',
  templateUrl: './sector-empresa.component.html',
  styleUrls: ['./sector-empresa.component.scss'],
  providers: [MessagesStatus]
})
export class SectorEmpresaComponent implements OnInit {
  
  @Output() cerrarAgregarSector: EventEmitter<boolean> = new EventEmitter();

  empresas : any = [];
  idEmpresa : any = [];
  dataFiltro : FormGroup;
  loading:boolean;
  abrirAgregarSector : boolean;
  rucProvFilter = new FormControl('');
  rucFilter = new FormControl('');
  dataSource =new MatTableDataSource( this.empresas); 
  filterValues = {
    Ruc: '',
    Proveedor:''
    }; 
    
    user : any;

   dataEnviar:any={} 
   cboSectores:any=[];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns: string[] = 
  ['checked','Num_Doc_Identificacion','Razon_Social','Sector','Scoring_Puntaje','Estado'];
  constructor(private empresaService:EmpresasService,private riesgoService:RiesgoService,private msgStatus:MessagesStatus) {

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));


   }

  ngOnInit() {
    this.listarEmpresas();
    this.lstcboSectores();

    this.rucFilter.valueChanges
    .subscribe(
      Ruc => {
        this.filterValues.Ruc = Ruc;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )

    this.rucProvFilter.valueChanges
    .subscribe(
      Proveedor => {
        this.filterValues.Proveedor = Proveedor;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )
  }

  update(el: Element, idSector: string) {
    if (idSector == null) { return; }
    this.guardarSector(idSector)
    
  }
  open(element:any){
    this.idEmpresa = element.idEmpresa;
  }

  lstcboSectores(){
    this.riesgoService.obtenerSectoresEconomicos().subscribe(
      res=>{
        this.cboSectores = res;
      }
    )
      }

  guardarSector(idSector){

    Swal.fire({
      title: 'Espere',
      text:'Guardando Información',
      type:'info',
      allowOutsideClick:false,
      heightAuto: false
      });
      Swal.showLoading();
      this.dataEnviar.idEmpresa = this.idEmpresa;
      this.dataEnviar.idSector = idSector;
      this.dataEnviar.Usuario = this.user.Usuario
      this.riesgoService.asignarSectorEmpresa(this.dataEnviar)
      .subscribe(resp => {
      
      Swal.fire({
        title: "Success",
        text: "Sector asignado correctamente",
        type: "success",
        allowOutsideClick: false,
        heightAuto: false
      }).then(res =>{
        
        if (res.value == true ){
          this.ngOnInit()       
        }
      
      });
      },(err: HttpErrorResponse)=> {
      this.loading = false;
      if (err.error instanceof ErrorEvent) {
        console.error("Error Event");
      } else {
        this.msgStatus.getMessage(err.status);            
      }
      Swal.fire({
        title: "ERROR",
        text: "SECTOR NO ASIGNADO. "+this.msgStatus.message ,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      })
      });
  }

  createFilter(): (data: any, filter: string) => boolean {
    return function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return  data.Num_Doc_Identificacion .toString().toLowerCase().indexOf(searchTerms.Ruc) !== -1
      && data.Razon_Social.toString().toLowerCase().indexOf(searchTerms.Proveedor) !== -1;
    }
  }

  CerrarPopUpSector(){   
    this.abrirAgregarSector = false; 
  }

  listarEmpresas(){
    this.loading = true
    this.empresaService.obtenerEmpresa().subscribe(
      res=>{
        this.empresas = res;
        this.dataSource = new MatTableDataSource(this.empresas);
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = this.createFilter();
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      }
    )
  }

  asignarSector(element){
    this.empresaService.datosEmpresaSector = element;
    this.abrirAgregarSector = true;
  }
}
